import { render } from "./WhatsappCtaItem.vue?vue&type=template&id=366d3985&scoped=true"
import script from "./WhatsappCtaItem.vue?vue&type=script&lang=ts"
export * from "./WhatsappCtaItem.vue?vue&type=script&lang=ts"

import "./WhatsappCtaItem.vue?vue&type=style&index=0&id=366d3985&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-366d3985"

export default script